import { getLocale } from 'umi';
import request from 'umi-request';

import { encrypt } from './AES-128';

const localUser = localStorage.getItem('userInfo');
const userInfo = localUser ? JSON.parse(localUser) : null;

const userID = localStorage.getItem('accountId');
// 自己观看上传
export const postWatchTime = (time: string) => {
  return request.post(
    `${process.env.UDSUrl}uds/cloud/watchDay/update?version=1`,
    {
      data: {
        localz: getLocale().replace(/-/gi, '_'),
        userId: localStorage.getItem('userCode'),
        accountId: localStorage.getItem('mobile'),
        countryCode: userInfo.countryCode,
        userWatchTime: time,
      },
    },
  );
};

// 好友观看上传
export const postRelateWatchTime = (
  userId: string,
  accountId: string,
  time: string,
) => {
  return request.post(
    `${process.env.UDSUrl}uds/cloud/watchDay/update?version=1`,
    {
      data: {
        userId: userId,
        accountId: accountId,
        relateWatchTime: time,
      },
    },
  );
};

export const postWatchList = () => {
  return request.post(
    `${process.env.UDSUrl}uds/cloud/watchDay/list?version=1`,
    {
      data: {
        userId: localStorage.getItem('userCode'),
        accountId: localStorage.getItem('mobile'),
        // countryCode: userInfo.countryCode,
      },
    },
  );
};

//上传接口
export const postExchange = (exchangeType: number) => {
  const dataStr = encrypt(
    `userId=${localStorage.getItem(
      'userCode',
    )}&accountId=${localStorage.getItem(
      'mobile',
    )}&exchangeType=${exchangeType}&timestamp=${new Date().getTime()}`,
  );

  return request.post(
    `${process.env.UDSUrl}uds/cloud/watchDay/exchange?version=1`,
    {
      data: {
        userId: localStorage.getItem('userCode'),
        accountId: localStorage.getItem('mobile'),
        exchangeType: exchangeType,
        sign: dataStr,
      },
    },
  );
};

export const biVod = (
  asset_type: string,
  asset_id: string,
  item_id: string,
  time: number,
  zb_assettime: number,
) => {
  try {
    const commonParams = {
      model: userInfo ? userInfo.appVer : 'unknown',
      user_id: userInfo ? userInfo.userCode : 'unknown',
      country_id: localStorage.getItem('countryCode'),
      city_id: null,
      device_id: userInfo ? userInfo.device : 'unknown',
      soft_v: '2.0.000',
      v: '1',
      site_id: '99',
      org_spid: '12',
      event: '8',
      error: '1',
      qb_assettime: 0,
    };
    return request.post(`${process.env.BiUrl}`, {
      data: {
        ...commonParams,
        create_datetime: new Date().getTime(),
        asset_type: asset_type,
        asset_id: asset_id,
        item_id: item_id,
        qb_datetime: new Date().getTime() - time,
        zb_datetime: new Date().getTime(),
        zb_assettime: zb_assettime,
        time: time,
      },
    });
  } catch (error) {
    console.log(error);
  }
};

export const logCollect = (
  asset_type: string,
  asset_id: string,
  item_id: string,
  time: number,
  zb_assettime: number,
  event: number,
) => {
  try {
    const commonParams = {
      model: userInfo ? userInfo.appVer : 'unknown',
      user_id: userInfo ? userInfo.userCode : 'unknown',
      country_id: localStorage.getItem('countryCode'),
      city_id: null,
      device_id: userInfo ? userInfo.device : 'unknown',
      soft_v: '2.0.000',
      v: '1',
      site_id: '99',
      org_spid: '12',
      error: '1',
      qb_assettime: 0,
    };
    return request.post(`${process.env.BiUrl}`, {
      data: {
        ...commonParams,
        event: event,
        create_datetime: new Date().getTime(),
        asset_type: asset_type,
        asset_id: asset_id,
        item_id: item_id,
        qb_datetime: new Date().getTime() - time,
        zb_datetime: new Date().getTime(),
        zb_assettime: zb_assettime,
        time: time,
      },
    });
  } catch (error) {
    console.log(error);
  }
};

export const loginHMVOD = (
  asset_type: string,
  asset_id: string,
  item_id: string,
  time: number,
  zb_assettime: number,
  event: number,
) => {
  try {
    const commonParams = {
      model: userInfo ? userInfo.appVer : 'unknown',
      user_id: userInfo ? userInfo.userCode : 'unknown',
      country_id: localStorage.getItem('countryCode'),
      city_id: null,
      device_id: userInfo ? userInfo.device : 'unknown',
      soft_v: '2.0.000',
      v: '1',
      site_id: '99',
      org_spid: '12',
      error: '1',
      qb_assettime: 0,
    };
    return request.post(`${process.env.BiUrl}`, {
      data: {
        ...commonParams,
        event: event,
        create_datetime: new Date().getTime(),
        asset_type: asset_type,
        asset_id: asset_id,
        item_id: item_id,
        qb_datetime: new Date().getTime() - time,
        zb_datetime: new Date().getTime(),
        zb_assettime: zb_assettime,
        time: time,
      },
    });
  } catch (error) {
    console.log(error);
  }
};
// 获取浏览器版本
function getBrowserName() {
  var userAgent = navigator.userAgent;
  if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
    return 'Opera';
  } else if (
    userAgent.indexOf('compatible') > -1 &&
    userAgent.indexOf('MSIE') > -1
  ) {
    return 'IE';
  } else if (userAgent.indexOf('Edge') > -1) {
    return 'Edge';
  } else if (userAgent.indexOf('Firefox') > -1) {
    return 'Firefox';
  } else if (
    userAgent.indexOf('Safari') > -1 &&
    userAgent.indexOf('Chrome') == -1
  ) {
    return 'Safari';
  } else if (
    userAgent.indexOf('Chrome') > -1 &&
    userAgent.indexOf('Safari') > -1
  ) {
    return 'Chrome';
  } else if (!!window.ActiveXObject || 'ActiveXObject' in window) {
    return 'IE>=11';
  } else {
    return 'Unkonwn';
  }
}
// 公共数据
const commonParams = {
  site_id: `${process.env.siteId}`,
  org_spid: `${process.env.orgSpid}`,
  device_id: userID ? userID : null,
  user_id: userID ? userID : null,
  log_type: 'CSW',
  v: '1',
  model: getBrowserName() ? getBrowserName() : 'unknown',
  soft_v: '1.0',
  province: '澳门',
  create_datetime: new Date().getTime(),
};
// 点播
export const play = (
  asset_id: string,
  asset_title: string,
  item_id: string,
  category_id: string | null,
  category_name: string | null,
  qb_datetime: number,
  zb_assettime: number,
  ep: string,
  asset_type: string,
  error: string,
  buffer_time: any,
  asset_from: string,
  play_permission: string,
) => {
  try {
    return request.post(`${process.env.BiUrl}`, {
      data: {
        ...commonParams,
        event: 8,
        asset_id: asset_id,
        item_id: item_id,
        asset_title: asset_title,
        category_id: category_id,
        category_name: category_name,
        qb_datetime: qb_datetime,
        zb_datetime: new Date().getTime(),
        qb_assettime: 0,
        zb_assettime: zb_assettime,
        ep: ep,
        asset_type: asset_type,
        time: qb_datetime ? new Date().getTime() - qb_datetime : 0,
        error: error,
        parent_page_type: localStorage.getItem('parentPageType'),
        parent_page_id: localStorage.getItem('parentPageId'),
        buffer_time: buffer_time * 1000,
        asset_from: asset_from,
        play_permission: play_permission,
        vip: play_permission,
      },
    });
  } catch (error) {
    console.log(error);
  }
};

// 订购
export const order = (pkg_type: string, pkg_id: string, order_msg: string) => {
  try {
    return request.post(`${process.env.BiUrl}`, {
      data: {
        ...commonParams,
        event: 201,
        pkg_type: pkg_type,
        pkg_id: pkg_id,
        action: 1,
        order_msg: order_msg,
        parent_page_id: localStorage.getItem('orderParentPageId')
          ? localStorage.getItem('orderParentPageId')
          : localStorage.getItem('parentPageId'),
        parent_page_type: localStorage.getItem('orderParentPageType')
          ? localStorage.getItem('orderParentPageType')
          : localStorage.getItem('parentPageType'),
        pay_type: 3,
        point: 1,
      },
    });
  } catch (error) {
    console.log(error);
  }
};

// 页面访问
export const page = (
  page_type: string,
  page_name?: string,
  page_id?: string,
) => {
  try {
    return request.post(`${process.env.BiUrl}`, {
      data: {
        ...commonParams,
        event: 104,
        page_type: page_type,
        page_name: page_name ? page_name : null,
        page_id: page_id ? page_id : null,
      },
    });
  } catch (error) {
    console.log(error);
  }
};

// 跳转看正片
export const jump = (
  asset_id: string,
  asset_title: string,
  asset_from: string,
  item_id: string,
  item_title: string,
) => {
  try {
    return request.post(`${process.env.BiUrl}`, {
      data: {
        ...commonParams,
        event: 109,
        asset_id: asset_id,
        asset_title: asset_title,
        asset_from: asset_from,
        item_id: item_id,
        item_title: item_title,
        item_duration: localStorage.getItem('duration')
          ? localStorage.getItem('duration')
          : 'unknown',
        error: '1',
      },
    });
  } catch (error) {
    console.log(error);
  }
};

// 云游戏跳转
export const cloudGame = (
  game_id: string,
  game_name: string,
  game_from: string,
) => {
  try {
    return request.post(`${process.env.BiUrl}`, {
      data: {
        ...commonParams,
        event: 106,
        game_id: game_id,
        game_name: game_name,
        game_from: game_from,
      },
    });
  } catch (error) {
    console.log(error);
  }
};

// 澳门好帮手埋点
export const product = (
  product_id: string,
  product_name: string,
  kind_id: string | null,
  kind_name: string | null,
  price: string | null,
) => {
  try {
    return request.post(`${process.env.BiUrl}`, {
      data: {
        ...commonParams,
        event: 111,
        product_id: product_id,
        product_name: product_name,
        kind_id: kind_id,
        kind_name: kind_name,
        price: price,
        error: 1,
      },
    });
  } catch (error) {
    console.log(error);
  }
};
// 直播埋点
export const live = (
  channel_id: string,
  channel_name: string,
  qb_datetime: number | null,
  zb_datetime: number | null,
  time: number | 0,
  error: number | null,
  buffer_time: any | 0,
) => {
  try {
    return request.post(`${process.env.BiUrl}`, {
      data: {
        ...commonParams,
        event: 9,
        channel_id: channel_id,
        channel_name: channel_name,
        qb_datetime: qb_datetime,
        zb_datetime: zb_datetime,
        time: time * 1000,
        error: error,
        buffer_time: parseInt(buffer_time * 1000),
      },
    });
  } catch (error) {
    console.log(error);
  }
};
